export enum PayableContractErrorOrigin {
    GET_PAYABLE_CONTRACTS = 'GET_PAYABLE_CONTRACTS',
    CREATE_PAYABLE_CONTRACT = 'CREATE_PAYABLE_CONTRACT',
    GET_PAYABLE_CONTRACT_BY_ID = 'GET_PAYABLE_CONTRACT_BY_ID',
    UPDATE_PAYABLE_CONTRACT = 'UPDATE_PAYABLE_CONTRACT',
}

export interface PayableContractError {
    type: PayableContractErrorOrigin,
    detail: any
}